// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_StoreInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /fechamentos/store
 *
 * Validates monthly accounting period creation requests.
 */
import { registerContract } from './validate'

export interface Fechamentos_StoreInput {
franquia_id: number
data_inicial: string
data_final: string
meta_faturamento: number
meta_clientes?: number
meta_itens?: number
}

registerContract('Fechamentos_StoreInput', {
  franquia_id:      { type: 'number',  required: true },
  data_inicial:     { type: 'string',  required: true },
  data_final:       { type: 'string',  required: true },
  meta_faturamento: { type: 'number',  required: true },
  meta_clientes:    { type: 'number',  required: false },
  meta_itens:       { type: 'number',  required: false },
})
